var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"heatmap"}},[_c('div',{ref:"svgar",staticClass:"svgar",attrs:{"id":"svgar"},domProps:{"innerHTML":_vm._s(_vm.svg)},on:{"mousemove":_vm.onMove}}),_c('div',{staticClass:"db"})])}
var staticRenderFns = []

export { render, staticRenderFns }